import moment from 'moment'
import _ from 'lodash'
// import 'moment/locale/zh-cn'
// moment.locale('zh-cn')

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? 'Good morning' : hour <= 11 ? 'Good morning' : hour <= 13 ? 'Good noon' : hour < 20 ? 'Good afternoon' : 'Good evening'
}

export function welcome () {
  const arr = ['Take a rest !', 'What are you going to have ?', 'I guess you may be tired.']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

// 将后台api分页信息，转换为STable组件需要信息
export function toSTablePage (apiPage) {
  if (apiPage) {
    return {
      pageSize: apiPage.pageSize,
      pageNo: apiPage.curPage,
      totalPage: apiPage.maxPage,
      totalCount: apiPage.maxRows,
      data: apiPage.datas
    }
  }
  return null
}

// 时间格式转换
export function dateTimeFormatA (date, pattern = 'MM/DD/YYYY HH:mm:ss') {
  if (date) {
    return moment(date).format(pattern)
  } else {
    if (date === '') {
      return ''
    }
    return ''
  }
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    // eslint-disable-next-line
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

// 根据出生日期计算生日 YYYY-MM-DD
export function getAge (birthday) {
  let age
  const birthdayArr = birthday.split('-')
  const birthdayYear = birthdayArr[0]
  const birthdayMonth = birthdayArr[1]
  const birthdayDay = birthdayArr[2]
  const today = new Date()
  const nowYear = today.getFullYear()
  const nowMonth = today.getMonth() + 1
  const nowDay = today.getDate()
  if (nowYear === birthdayYear) {
    age = 0 // 同年 则为0岁
  } else {
    const ageDiff = nowYear - birthdayYear // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthdayMonth) {
        const dayDiff = nowDay - birthdayDay // 日之差
        if (dayDiff < 0) {
          age = ageDiff - 1
        } else {
          age = ageDiff
        }
      } else {
        const monthDiff = nowMonth - birthdayMonth // 月之差
        if (monthDiff < 0) {
          age = ageDiff - 1
        } else {
          age = ageDiff
        }
      }
    } else {
      age = '未知' // 返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return age // 返回周岁年龄
}

// 首字母大写
export function capitalize(str) {
  return _.capitalize(str)
}
